// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** St. Pierre & Miquelon */
const PM =
  /^(?:708(?:4[0-5]|5[0-6])\d{4}|(?:[236-9]\d|4[02-489]|5[02-9])\d{4})$/;

export default PM;
